export * from './EntityPageExtensions';
